/**
 * Regulatory reports feature API layer — OpenAPI-first.
 *
 * Thin wrappers over orval-generated hooks from
 * `@shared/api/generated/regulatory-reports/regulatory-reports`.
 */
import type { ListRegulatoryReportsParams } from "@shared/api/generated/model";
import {
  useGenerateRegulatoryReport as useGenGenerate,
  useListRegulatoryReports as useGenList,
} from "@shared/api/generated/regulatory-reports/regulatory-reports";

export type {
  GenerateReportRequest,
  ListRegulatoryReportsParams,
  RegulatoryReportListResponse,
  RegulatoryReportResponse,
} from "@shared/api/generated/model";

export {
  downloadRegulatoryReport,
  downloadRegulatoryReportArchive,
} from "@shared/api/generated/regulatory-reports/regulatory-reports";

export const useRegulatoryReports = (params?: ListRegulatoryReportsParams) => {
  return useGenList(params, {
    query: { staleTime: 30_000 },
  });
};

export const useGenerateReport = () => {
  return useGenGenerate();
};
